export class GetPosicionAction {
  static readonly type = '[Dashboard] GetPosicionAction';
}
